import React from 'react';
import { Box } from '@mui/material';

import theme from 'config/theme';
import styles from '../menu.style';

const MenuWrapper = ({ children }) => {
  return (
    <Box
      sx={{
        ...styles.menuList,
        [theme.breakpoints.down('md')]: {
          height: `calc(100hv - ${theme.customValues.topBarHeight} - 90px)`,
        },
      }}
    >
      {children}
    </Box>
  );
};

export default MenuWrapper;
